import React from 'react';
import './style/global.css';

import Routes from './routes';

function App() {
  return (
    <Routes />
  );
}

export default App;
